import script from "./CommentBalloon.vue?vue&type=script&setup=true&lang=js"
export * from "./CommentBalloon.vue?vue&type=script&setup=true&lang=js"

import "./CommentBalloon.vue?vue&type=style&index=0&id=1ff5b31c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ff5b31c"]])

export default __exports__